import { render, staticRenderFns } from "./CarouselIndicators.vue?vue&type=template&id=24228422&"
import script from "./CarouselIndicators.vue?vue&type=script&lang=ts&"
export * from "./CarouselIndicators.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselIndicators.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports